import Icon, {iconTypes} from "../../common/components/Icon.jsx";

import {Localization} from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";


export default class DeliveringDate extends React.PureComponent {
    render(){
        const {
            localization,
            deliveryDate,
            deliveryTime,
            deliveryDelayDesc,
            useIcon,
        } = this.props;
        return (
            <div className="delivering-detail">
                {useIcon && (
                    <div className="icon-area">
                        <div className="card-icon delivering-detail-icon">
                            <Icon type={iconTypes.truck} />
                        </div>
                    </div>
                )}
                <div className="delivering-detail-info-row">
                    <div className="delivering-detail-header">{deliveryDate}</div>
                    <div>
                        <div className="delivering-detail-info">{deliveryTime}</div>
                        {!deliveryDelayDesc ? (
                            <div className="delivering-detail-info-col">
                                <div className="delivering-detail-circle-green" />
                                <div className="delivering-detail-info">{localization.text("dashboard","onTime")}</div>
                            </div>
                        ) : (
                            <div className="delivering-detail-info-col">
                                <div className="delivering-detail-circle-orange" />
                                <div className="delivering-detail-info">{deliveryDelayDesc}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
DeliveringDate.propTypes = {
    localization: Localization.propTypes.isRequired,
    deliveryDate: PropTypes.string.isRequired,
    deliveryTime: PropTypes.string.isRequired,
    deliveryDelayDesc: PropTypes.string,
    useIcon: PropTypes.bool.isRequired,
    delivery: PropTypes.object,
};
DeliveringDate.defaultProps = {
    useIcon: true,
};